import { FC } from 'react';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { SxProps } from '@mui/material';

export interface FullSizeLoaderProps {
	sx?: SxProps;
}

const FullSizeLoader: FC<FullSizeLoaderProps> = ({ sx }) => (
	<Box
		sx={{
			width: '100%',
			height: '100%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			...sx,
		}}
	>
		<CircularProgress />
	</Box>
);

export default FullSizeLoader;
